import { render, staticRenderFns } from "./Ydfw.vue?vue&type=template&id=6a4cf309&"
import script from "./Ydfw.vue?vue&type=script&lang=js&"
export * from "./Ydfw.vue?vue&type=script&lang=js&"
import style0 from "./Ydfw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports